import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import { App } from '~/App';
import { ConfigProvider } from '~/components/ConfigProvider';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <ConfigProvider>{(config) => <App config={config} />}</ConfigProvider>
  </StrictMode>,
);
